// Qlik-hosted assets (styles + AMD loader) needed by any page that renders
// Qlik/qdt-components charts. These must be resolved from runtime config
// ($config, backed by publicRuntimeConfig) rather than nuxt.config.js's
// static `head` block, which is baked at build time and can drift from the
// Qlik host actually configured for a given deployment (dev/test/prod).
function qlikAssetsHead($config) {
  const base = $config.FullQlikPublicUrl

  return {
    link: [
      {
        hid: 'qlik-styles-css',
        crossorigin: 'use-credentials',
        rel: 'stylesheet',
        href: `${base}/resources/autogenerated/qlik-styles.css`
      }
    ],
    script: [
      { hid: 'accessibe', src: '/accessibe.js', body: true },
      {
        hid: 'qlik-require-js',
        crossorigin: 'use-credentials',
        src: `${base}/resources/assets/external/requirejs/require.js`
      }
    ]
  }
}

export { qlikAssetsHead }
